<template>
  <el-dialog :close-on-click-modal="false" append-to-body title="复核意见" :visible.sync="dialogFormVisible"
    @open="handleDialogOpen" width="1200px">
    <div style="margin-top: 20px" class="table">
      <div></div>
      <div style="display: flex">
        <el-button @click="storage()" style="height:28px" size="mini" type="success">暂存</el-button>
        <el-button @click="clear()" style="height:28px" size="mini" type="primary">清空</el-button>
      </div>
    </div>
    <el-form class="dialog" :model="ruleForm" :rules="rules" ref="form"
      label-width="120px" status-icon>
      <el-form-item label="模块/单元" prop="module">
        <el-select
          clearable
          v-model="ruleForm.module"
          placeholder="请选择模块/单元"
        >
          <el-option label="基础信息" value="基础信息"></el-option>
          <!-- <el-option label="人员机构" value="人员机构"></el-option> -->
          <el-option label="风险单元" value="风险单元"></el-option>
          <!-- <el-option label="场所管理" value="场所管理"></el-option>
          <el-option label="设备管理" value="设备管理"></el-option>
          <el-option label="作业管理" value="作业管理"></el-option>
          <el-option label="隐患排查治理情况" value="隐患排查治理情况"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="字段名" prop="field_name">
        <el-input placeholder="字段名" v-model="ruleForm.field_name"></el-input>
      </el-form-item>
      <el-form-item label="问题描述" prop="remark">
        <el-input type="textarea" :rows="5" placeholder="问题描述" v-model="ruleForm.remark"></el-input>
      </el-form-item>
      <el-form-item label="问题整改期限" prop="deadline_time">
        <el-date-picker
          clearable
          v-model="ruleForm.deadline_time"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="截图(可多张)" prop="image_list">
        <span slot="label">
          <span>截图</span>
        </span>
        <el-upload
          class="upload-demo"
          name="image"
          :data="uploadParams"
          :headers="uploadHeaders"
          action="/apps/res/uploadImage"
          :before-upload="beforeAvatarUpload"
          :before-remove="(file, fileList) => beforeRemove(file, fileList, 'image_list')"
          multiple
          :limit="10"
          :file-list="images"
          :on-success="(res, file, fileList) => handlepictureSuccess(res, file, fileList, 'image_list')"
          :on-exceed="handleExceed"
          list-type="picture-card">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5M</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="附件" prop="file">
        <div style="display: flex">
          <el-upload :on-change="() => checkRules('file')" action="/apps/res/uploadFile" name="file"
            :headers="uploadHeaders" :data="uploadParams" :show-file-list="false"
            :on-success="(res, file) => handleAvatarSuccess(res, file, 'file')"
            :before-upload="beforeAvatarUpload">
            <el-button size="small" type="primary">上传附件</el-button>
          </el-upload>
          <div v-if="ruleForm.file">
            <el-link
              @click="$showFile({url: ruleForm.file})"
              :underline="false"
              style="margin-left:15px"
              target="_blank"
              type="primary"
            >预览</el-link>
            <el-link
              :underline="false"
              style="margin-left:15px"
              :href="ruleForm.file"
              target="_blank"
              type="primary"
            >下载</el-link>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideForm">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {api} from '@/api/api'
import { dialogMixins, multipleImgMixins, fileMixins } from '@/mixins/qiboMixins'
export default {
  props: {
  },
  mixins: [dialogMixins, multipleImgMixins, fileMixins],
  computed: {

  },
  data() {
    return {
      images: [],
      ruleForm: {
        module: null, // '模块/单元',
        field_name: null, // '字段名',
        remark: null, // '问题描述',
        image_list: null, // '图片列表',(用json或者逗号分隔都可以，客户端来定)
        file: null, // '文件',
        deadline_time: null, // 最后期限,
      },
      rules: {
        // module: [
        //   { required: true, message: '请输入模块/单元', trigger: 'blur' }
        // ],
        field_name: [
          { required: true, message: '请输入字段名', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入问题描述', trigger: 'blur' }
        ],
        // image_list: [
        //   { required: true, message: '请上传图片', trigger: 'change' }
        // ],
        // file: [
        //   { required: true, message: '请上传附件', trigger: 'change' }
        // ]
      }
    }
  },
  mounted() {
  },
  methods: {
    submitForm(needCompanyId) { // 默认需要传companyId,检查清单特判不用，其他的不知道要不要
      this.$refs['form'].validate((valid) => {
        if (!valid) {
          return
        }
        let params = this.handleParams ? this.handleParams() : { ...this.ruleForm }
        if (this.dataId) {
          params.id = this.dataId
        }
        if (this.$store.state.companyId && this.$store.state.companyId !== 'null' && needCompanyId) {
          params.company_id = this.$store.state.companyId
        }
        this.$http.post(api[`addOrUpdateRecheck`], params).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: params.id ? '修改成功' : '新增成功',
              type: 'success'
            })
            this.dialogFormVisible = false
            this.$emit('refreshTable')
            localStorage.clear('reviewForm')
          } else {
            this.$message({
              message: params.id ? `修改失败 ${res.data.msg}` : `新增失败 ${res.data.msg}`,
              type: 'warning'
            })
          }
        })
      })
    },
    handleshowForm(row){
      this.images = []
      var date = new Date();
      date.setTime(date.getTime()+5*24*60*60*1000);
      var s1 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate());
      this.ruleForm.deadline_time = s1
      if(localStorage.getItem('reviewForm')){
        this.ruleForm = JSON.parse(localStorage.getItem('reviewForm'))
      }
    },
    handleRuleForm (rowData) {
      this.images = []
      if (rowData.image_list) {
        this.ruleForm.image_list = rowData.image_list.split(',')
        for (let item of this.ruleForm.image_list) {
          this.images.push({
            url: item
          })
        }
        this.ruleForm.image_list = this.images
      }
    },
    handleParams () {
      let params = {...this.ruleForm}
      if (params.image_list && params.image_list.length > 0) {
        params.image_list = params.image_list.map(item => item.url).join(',')
      }
      return params
    },
    clear(){
      for (let key in this.ruleForm) {
        this.ruleForm[key] = null
      }
      this.images = []
      localStorage.clear('reviewForm')
    },
    // 暂存
    storage(){
      localStorage.setItem('reviewForm',JSON.stringify(this.ruleForm))
    }
  }
}
</script>

<style scoped>
.dialog .el-input {
  /* width: 200px; */
}
.dialog {
  max-height: 700px;
}
.table {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/recheck/addOrUpdateForm.vue